<app-topbar-nav-links [links]="links" [upgradeLink]="upgradeLink" (linkClick)="close()"></app-topbar-nav-links>
